import {action, observable, observer} from '@api'
import Vec from '@tldraw/vec'
import type { TLPointerEventHandler } from '@tldraw/core'
import { Utils } from '@tldraw/core'
import { SessionType, TDShapeType } from '@modules/whiteboard'
import {BaseTool} from '@modules/whiteboard/tools/BaseTool'

export class StickyTool extends BaseTool {
  type = 'sticky' as const

  @observable shapeId?: string

  /* ----------------- Event Handlers ----------------- */

  @action onPointerDown: TLPointerEventHandler = () => {
    const {
        app: {
          selectTool, appState, appState: {isToolLocked},
          currentPoint: point, grid, patchCreate, tools: {startSession},
          ui: {currentPageId: parentId, currentStyle}, shapeUtils: {sticky}
        },
        nextChildIndex: childIndex
      } = this
      
     if (this.status === 'creating') {
      this.status = 'idle'

      if (!isToolLocked) {
        selectTool('select')
      }

      return
    }

    if (this.status === 'idle') {
      const id = Utils.uniqueId()

      this.shapeId = id

      const newShape = sticky.create({
        id,
        parentId,
        childIndex,
        point: grid ? Vec.snap(point, grid) : point,
        style: _.cloneDeep(currentStyle)
      })

      const bounds = sticky.getBounds(newShape)

      newShape.point = Vec.sub(newShape.point, [bounds.width / 2, bounds.height / 2])

      this.app.createShapes(newShape)

      this.app.tools.startSession(SessionType.Translate)

      this.status = 'creating'
    }
  }

  @action onPointerUp: TLPointerEventHandler = () => {
    if (this.status === 'creating') {
      this.status = 'idle'
      this.app.tools.completeSession()
      this.app.selectTool('select')
      this.app.setEditingId(this.shapeId)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/tools/StickyTool/StickyTool.ts